import React from 'react'
import TagsInput from 'react-tagsinput'
import Autosuggest from 'react-autosuggest'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeCurrentTag } from '../../actions/tags';
import { getLabel } from "../../language";
import { APP_CONFIG } from "../../appconfig";
import TagsModal from "./TagsModal";
const defaultAvatar = APP_CONFIG.defaultAvatar;

class TagsAutocomplete extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tags: [],
      isShowMessage: false,
      tagNames: [],
      showTagModal:false,
      AddNewTags:false
    }

    this.handleChange = this.handleChange.bind(this);
    this.defaultRenderTag = this.defaultRenderTag.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.clearTagsField = this.clearTagsField.bind(this);
  }

  clearTagsField() {
    this.setState({ tags: [] })
  }

  componentWillReceiveProps(nextProps) {
    if ((!nextProps.formatedTags || nextProps.formatedTags.length === 0) &&
      this.props.formatedTags && this.props.formatedTags.length > 0) {
      this.clearTagsField();
    }
    if ((nextProps.formatedTags && nextProps.formatedTags.length > 0) !== this.props.formatedTags) {
      let tagNames = nextProps.formatedTags.map(item => {
        return item.text
      });
      this.setState({ tags: tagNames })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.state.AddNewTags){
      this.state.tags.splice(this.state.tags.length - 2, 1);
      this.props.formatedTags.splice(this.props.formatedTags - 2, 1);
      this.setState({AddNewTags:false});
      this.setState({tags:this.state.tags});
      this.props.setTags(this.state.tags);
    }
  }

  async handleChange(tags) {
    await this.setState({ tags });
    if (tags.length <= 7) {
      this.props.setTags(tags);
      this.setState({ isShowMessage: false })
    } else {
      this.setState({showTagModal:true});
      this.setState({ isShowMessage: true });
      this.props.setTags(tags);
    }
  }

  onChangeInput(value) {
    this.props.onChangeInput(value);
  }

  handleDelete(i) {
    const { tags, tagNames } = this.state;
    const tagsArray = this.props.tagsArray
    if (tags.length > 0) {
      tagsArray.splice(i, 1)
      tags.splice(i, 1);
      this.setState({ tags: tags, isShowMessage: false });
      this.props.removeCurrentTag(tagsArray);
    }
  }

  getTagByName(tagName) {
    const { tagsFromQuickPost } = this.state;
    const { suggestions, formatedTags } = this.props;
    let matchedSuggestion = suggestions && !suggestions.hasError && suggestions.length > 0 ? suggestions.find(item => item.name === tagName) : null;
    let matchedTag = formatedTags && formatedTags.length > 0 ? formatedTags.find(item => item.text === tagName) : null;

    return matchedSuggestion || matchedTag || false;
  }

  defaultRenderTag(props) {
    let { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, className, ...other } = props;
    const tagObj = this.getTagByName(tag);

    return (
      <span key={key} className={className} {...other}>
        {tagObj && tagObj.type.toLowerCase() === "polly" ?
          <img className="tag-img" src={tagObj.photoName ? `/images/people/${tagObj.personID}/official/${tagObj.photoName}` : defaultAvatar} alt="" />
          : null}
        {getTagDisplayValue(tag)}
        {!disabled &&
          <a className={classNameRemove} onClick={(e) => this.handleDelete(key)} />
        }
      </span>
    )
  }

  render() {
    const { suggestions } = this.props;
    const { isShowMessage, tags, tagNames, showTagModal } = this.state;
    function autocompleteRenderInput({ addTag, ...props }) {
      const handleOnChange = (e, { newValue, method }) => {
        if (method === 'enter') {
          e.preventDefault()
        } else {
          props.onChange(e)
          this.onChangeInput(newValue);
        }
      }

      const renderSuggestion = suggestion => (
        <div className="suggestion-item">
          <img className="tag-list-img" src={suggestion.photoName ? `/images/people/${suggestion.personID}/official/${suggestion.photoName}` : defaultAvatar} />
          {suggestion.name}
        </div>
      );

      const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
      const inputLength = inputValue.length

      return (
        <Autosuggest
          ref={props.ref}
          suggestions={suggestions}
          shouldRenderSuggestions={(value) => value && value.trim().length > 0}
          getSuggestionValue={(suggestion) => suggestion.name}
          renderSuggestion={renderSuggestion}
          inputProps={{ ...props, onChange: handleOnChange }}
          onSuggestionSelected={(e, { suggestion }) => {
            addTag(suggestion.name)
          }}
          onSuggestionsClearRequested={() => { }}
          onSuggestionsFetchRequested={() => { }}
        />
      )
    }
    return (
      <div className="tags-input-wrapper">
        <TagsModal showTagModal={showTagModal} setTags={() => {
          this.setState({AddNewTags: true});
          this.setState({showTagModal: false});
        }}
                   onHide={() => {
                     this.setState({showTagModal: false});
                     this.props.formatedTags.pop();
                     this.state.tags.pop();
                   }}/>
        <TagsInput
          renderInput={autocompleteRenderInput.bind(this)}
          value={tags && tags.length > 0 ? tags : tagNames || []}
          onChange={this.handleChange}
          renderTag={this.defaultRenderTag}
          maxTags="8"
        />
        <span className={`tags-limit ${isShowMessage ? '' : 'hidden'}`}>{getLabel(205)}</span>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  tagsArray: state.tags.tags
})

const mapDispatchToProps = dispatch => ({
  removeCurrentTag: dispatch(removeCurrentTag)
});

TagsAutocomplete.defaultProps = {
  suggestions: [],
  formatedTags: []
}

TagsAutocomplete.propTypes = {
  suggestions: PropTypes.instanceOf(Array),
  onChange: PropTypes.func,
  setTags: PropTypes.func.isRequired,
  formatedTags: PropTypes.instanceOf(Array)
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsAutocomplete);